import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon } from "@angular/material/icon";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxJsonViewerModule } from 'ngx-json-viewer';

@Component({
  selector: 'app-log-detail-data-modal',
  styleUrl: './log-detail-data-modal.component.scss',
  templateUrl: './log-detail-data-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIcon,
    NgxJsonViewerModule
  ],
})
export class LogDetailDataModalComponent {

  constructor(
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ){
  }

  ngAfterViewInit():void {
  }
  
  onSubmit() {
    this.dialogRef.close("success")
  }

  copyToClipboard() {
    if(this.data){
      navigator.clipboard.writeText(JSON.stringify(this.data, null, 2)).then(() => {
        this.snackBar.open("JSON copiado", "Cerrar", { duration: 5000});
      }).catch(err => {
        this.snackBar.open(err.error.message || "Error al copiar texto.","Cerrar",{ duration: 5000});
      });
    }
  }
}


